import { atom } from "recoil";

export const selectedMeditationRecordKeyAtom = atom<string | undefined>({
  key: "selectedMeditationRecordKey",
  default: undefined,
});
